<div class="tab-content"><h2>Main billing &amp; shipping contacts</h2><p class="address-help">Choose the primary contact and saved address for each purpose. These are offered automatically when creating an order.</p>
  @if(CustomerDetails){
  <div class="address-block-cards">
    @for(type of Types; track type){
    <div class="address-block-card">
      <div class="address-block-header">
        <span>{{type}} contact</span>
        <div class="header-icons">
          <mat-icon class="header-icon" [class.disabled]="!canEdit" (click)="editAddress(type)">edit</mat-icon>
          <mat-icon class="header-icon" [class.disabled]="!canEdit" (click)="addAddress(type)">add</mat-icon>
          <mat-icon class="header-icon" [class.disabled]="!canEdit || !selectedAddress(type)" (click)="deleteAddress(type)">delete</mat-icon>
        </div>
      </div>

      @if(selectedAddress(type); as current){
      <div class="address-block-body">
        <div class="name-row">
          @if(current.AddressName){<span class="address-company-name">{{current.AddressName}}</span>}
          @if(current.IsDefault){<span class="primary-badge">Primary</span>}
        </div>
        <div>{{current.Street}}</div>
        <div>{{current.City}}, {{current.State}} {{current.ZipCode}}</div>
        @if(current.Country){<div>{{current.Country}}</div>}
      </div>
      } @else {
      <div class="address-block-empty">No {{type.toLowerCase()}} address on file</div>
      }

      <div class="address-block-contact"><strong>{{selectedAddress(type)?.FirstName}} {{selectedAddress(type)?.LastName}}</strong><p *ngIf="!selectedAddress(type)?.CustomerContactID">Link a saved customer contact using Edit.</p>
        <div><span class="contact-label">Phone:</span> {{selectedAddress(type)?.Phone || '—'}}</div>
        <div><span class="contact-label">Email:</span> {{selectedAddress(type)?.Email || '—'}}</div>
      </div>

      @if(listFor(type).length){
      <select class="address-select" [ngModel]="selectedIdFor(type)" (ngModelChange)="setSelectedId(type, $event)">
        @for(addr of listFor(type); track addr.CustomerShipToAddressID){
        <option [value]="addr.CustomerShipToAddressID">{{optionLabel(addr)}}</option>
        }
      </select>
      <rms-checkbox label="Primary" [disabled]="!canEdit" [ngModel]="selectedAddress(type)?.IsDefault || false" (ngModelChange)="setPrimary(type, $event)"></rms-checkbox>
      }
    </div>
    }
  </div>
  }
</div>
